import { render, staticRenderFns } from "./Goto.vue?vue&type=template&id=0c293059&"
import script from "./Goto.vue?vue&type=script&lang=js&"
export * from "./Goto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports